export const doctorDisplayName = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

export const doctorNameOrDash = (value: unknown): string => doctorDisplayName(value) || '-';

export const doctorOptionLabel = (label: string, code?: string): string => {
  const name = doctorDisplayName(label);
  return code ? `${name} (${code})` : name;
};
